import { NavLink } from 'react-router-dom'
import {
  LayoutDashboard,
  Activity,
  Building2,
  Settings,
  Users,
} from 'lucide-react'
import { cn } from '@/lib/utils'
import { tenantConfig } from '@/lib/tenant'
import { useAuth } from '@/lib/auth'

const baseNavItems = [
  { to: '/overview', label: 'Overview', icon: LayoutDashboard },
  { to: '/events', label: 'Events', icon: Activity },
  { to: '/brands', label: 'Brands', icon: Building2 },
  { to: '/settings', label: 'Settings', icon: Settings },
]

const adminNavItems = [{ to: '/users', label: 'Users', icon: Users }]

export function Sidebar() {
  const { isAdmin } = useAuth()
  const navItems = isAdmin ? [...baseNavItems, ...adminNavItems] : baseNavItems

  return (
    <aside className="flex w-60 shrink-0 flex-col bg-sidebar text-sidebar-foreground">
      <div className="flex h-16 items-center border-b border-white/10 px-6">
        <span className="text-lg font-semibold tracking-tight">
          {tenantConfig.displayName}
        </span>
      </div>
      <nav className="flex flex-1 flex-col gap-1 p-4">
        {navItems.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors',
                isActive
                  ? 'bg-white/10 text-white'
                  : 'text-sidebar-foreground/70 hover:bg-white/5 hover:text-white',
              )
            }
          >
            <Icon className="h-4 w-4" />
            {label}
          </NavLink>
        ))}
      </nav>
      <div className="border-t border-white/10 p-4 text-xs text-sidebar-foreground/50">
        Attribution Platform
      </div>
    </aside>
  )
}
